export enum BucketFunctionApiEnum {
    INDIVIDUAL_SUM = 'INDIVIDUAL_SUM',
    INDIVIDUAL_AVG = 'INDIVIDUAL_AVG',
    INDIVIDUAL_MAX = 'INDIVIDUAL_MAX',
    INDIVIDUAL_MIN = 'INDIVIDUAL_MIN',
    INDIVIDUAL_COUNT = 'INDIVIDUAL_COUNT'
}
